/**
 * Parse int safe with a fallback
 * @param {string} numberlike
 * @param {number} fallback
 * @return {number}
 */
const parseIntSafe = (numberlike, fallback) => {
    const num = Number.parseInt(numberlike, 10);
    return Number.isNaN(num) ? fallback : num;
};

export { parseIntSafe };
